import { ERegion, EObjectType, EPriceType } from 'shared/types/form';
import { IFormState } from '../../slices/formSlice/formSlice';

export function priceDescriptionVisible(formState: IFormState) {
  return formState.data.priceType !== null && formState.data.priceType !== EPriceType.Free;
}

export function locationVisible(formState: IFormState) {
  return (
    formState.data.moscow !== null &&
    formState.data.moscow !== ERegion.Moscow &&
    formState.data.moscow !== ERegion.MoscowRegion
  );
}

export function studioValueVisible(formState: IFormState) {
  return formState.data.objectType === EObjectType.Flat;
}
